import ApiInstance from "./ApiInstance";

export interface Mutualiteit {
  code: string;
  name: string;
  perSessionCents: number;
  maxSessionsPerYear: number;
  yearlyCapCents: number;
  autoSettled: boolean;
  conditions?: string;
  infoUrl?: string;
}

export interface ReimbursementPreview {
  fundCode: string;
  fundName: string;
  perSessionCents: number;
  youPayCents: number;
  maxSessionsPerYear: number;
  autoSettled: boolean;
  conditions?: string;
  infoUrl?: string;
  notEligible?: boolean;
  notEligibleReason?: string;
}

class MutualiteitApi {
  async list(): Promise<Mutualiteit[]> {
    const { data } = await ApiInstance.getApi().get("/mutualiteiten");
    return data.mutualiteiten;
  }
  // Reimbursement preview, optionally gated by a specific provider's credentials.
  async reimbursementPreview(fundCode: string, priceCents: number, psychologistId?: string): Promise<ReimbursementPreview> {
    const { data } = await ApiInstance.getApi().get("/mutualiteiten/reimbursement", {
      params: { fundCode, priceCents, ...(psychologistId ? { psychologistId } : {}) },
    });
    return data;
  }
}

const mutualiteitApi = new MutualiteitApi();
export default mutualiteitApi;
